// File: frontend/src/components/Pipeline/stagePlaybook.js
// Playbook comercial por etapa do pipeline: o que o vendedor deve fazer AGORA
// com uma oportunidade nesta etapa. Camada estática (sem IA) — complementa o
// NbaCard (sugestão por IA) na ficha da oportunidade.
//
// `type` decide o que o clique executa na ficha da oportunidade:
//   'send_email'       → EmailComposeModal (rascunho Gemini + envio real via actuator n8n)
//   'schedule_meeting' → ScheduleMeetingModal (Google Calendar + Meet via actuator n8n)
//   'call'|'task'      → ActivityForm (registro manual da atividade)
//   null               → orientação sem ação direta
// Os tipos de actuator degradam para ActivityForm se a oportunidade não tem contato.

export const STAGE_PLAYBOOK = {
  lead: {
    hint: 'Qualificar: valide o contato e entenda a dor',
    actions: [
      { label: 'Ligar / WhatsApp em até 24h', type: 'call' },
      { label: 'Validar e-mail e telefone do lead', type: null },
      { label: 'Registrar a dor principal na descrição', type: null },
    ],
  },
  qualified: {
    hint: 'Agendar a reunião de descoberta',
    actions: [
      { label: 'Agendar reunião (Calendar + Meet)', type: 'schedule_meeting' },
      { label: 'Confirmar decisor e orçamento', type: null },
      { label: 'Preparar pauta com o contexto do lead', type: null },
    ],
  },
  proposal: {
    hint: 'Enviar a proposta e combinar o follow-up',
    actions: [
      { label: 'Enviar proposta por e-mail (rascunho IA)', type: 'send_email' },
      { label: 'Agendar follow-up 2 dias após o envio', type: 'task' },
      { label: 'Mapear objeções e quem decide', type: null },
    ],
  },
  negotiation: {
    hint: 'Resolver objeções e definir data de decisão',
    actions: [
      { label: 'Responder objeções por e-mail (rascunho IA)', type: 'send_email' },
      { label: 'Alinhar condições/desconto com a gestão', type: null },
      { label: 'Definir data-limite de decisão com o cliente', type: 'task' },
    ],
  },
  closed_won: {
    hint: 'Onboarding: contrato e kickoff',
    actions: [
      { label: 'Enviar contrato por e-mail (rascunho IA)', type: 'send_email' },
      { label: 'Agendar kickoff/onboarding (Calendar + Meet)', type: 'schedule_meeting' },
      { label: 'Apresentar o time de implantação', type: null },
    ],
  },
  closed_lost: {
    hint: 'Registrar o motivo e programar recontato',
    actions: [
      { label: 'Registrar motivo da perda', type: null },
      { label: 'Agendar recontato em 90 dias', type: 'task' },
    ],
  },
};

export const getStagePlaybook = (stage) => {
  const key = (stage ?? '').toString().trim().toLowerCase();
  return STAGE_PLAYBOOK[key] || null;
};
